<script>
import SpinnerLoader from '../loaders/SpinnerLoader';
export default {
    components: {
        SpinnerLoader
    },
    props: {
        exportLoader: Boolean,
        exportDataFetch: Function,
        startDownload: Function,
        finishDownload: Function,
        fileName: String,
    },
};
</script>

<template>
    <div>
        <SpinnerLoader 
            v-if="exportLoader"
            classes="spinner-border text-success"
            role="status"
            title="Loading..."
        />
        <download-excel
            v-if="!exportLoader"
            :fetch="exportDataFetch"
            class="btn btn-success waves-effect waves-light mb-2 me-2"
            :name="fileName"
            type="csv"
            :before-generate="startDownload"
            :before-finish="finishDownload"
        >
            <i class="mdi mdi-download me-1"></i>
            Export in CSV
        </download-excel>
    </div>
</template>
